import { render, staticRenderFns } from "./Rasio.vue?vue&type=template&id=0c452e88"
import script from "./Rasio.vue?vue&type=script&lang=js"
export * from "./Rasio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports